import React from 'react';

// Packages
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

// Pages
import HomePage from '../Pages/Home';
import TermsPage from '../Pages/Terms';

// Components
import FooterComponent from '../Component/Footer';

function App() {
    return (
        <Router>
            <Switch>
                <Route path="/terms">
                    <TermsPage />
                </Route>
                <Route path="/">
                    <HomePage />
                </Route>
            </Switch>

            <FooterComponent />
        </Router>
    );
}

export default App;
